// Cache media query objects
export const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const slowUpdateQuery = window.matchMedia('(update: slow)');

// Cache URL parameter parsing result
let motionUrlParam = null;
let urlParamParsed = false;

const parseMotionUrlParam = () => {
    if (!urlParamParsed) {
        const urlParams = new URLSearchParams(window.location.search);
        // Only ?motion=false disables motion; absent or any other value leaves it enabled
        motionUrlParam = urlParams.get('motion') !== 'false';
        urlParamParsed = true;
    }
    return motionUrlParam;
};

const isMotionAllowed = () => {
    // Check if motion is turned off by using url parameter ?motion=false (cached)
    const motionUrlEnabled = parseMotionUrlParam();

    // Check if user prefers reduced motion (OS setting)
    const noReducedMotionPreference = !reducedMotionQuery.matches;

    // Check if the device has a screen with a slow refresh rate, e.g. e-ink or a cheap smartphone
    const noSlowRefreshRate = !slowUpdateQuery.matches;

    return noSlowRefreshRate && noReducedMotionPreference && motionUrlEnabled;
};

export default isMotionAllowed;
